import { render, staticRenderFns } from "./MemberListGiftLayout.vue?vue&type=template&id=5aa5cbe0&scoped=true&"
import script from "./MemberListGiftLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListGiftLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5cbe0",
  null
  
)

export default component.exports